// import React from 'react'
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import TopBar from './topbar/TopBar'
// import './portal.css'
// import SideBar from './Sidebar/SideBar';
// import { SidebarProvider } from '../Sidebar/SidebarContext';
// import UserManagmntModule from './usersMangmnt/UserManagmntModule';

// function portal() {
//   return (
//     <SidebarProvider>
//     <div>
//          <div className="bg-color h-screen overflow-x-scroll sm:overflow-x-auto">
//           <div className='flex overflow-x-scroll'>
//             <div className='md:w-[15%] h-screen sm:w-0'>
//               <SideBar />
//             </div>
//             <div className='md:w-[85%] sm:w-[100%] w-full bg-[#F6F6F6]'>
//               <div className='md:w-[85%] sm:w-[100%] w-full'>
//               <TopBar />
//               </div>
//               <section className="sm:content px-3.5 pb-3.5 w-11/12 pt-[110px] sm:mb-10 sm:mt-0 container mb-12 mx-auto">
//               <Routes>
//               {/* <Route path="/" element={<DashBoard />} />
//               <Route path="dashboard" element={<DashBoard />} /> */}
//               <Route path="userManagmnt/*" element={<UserManagmntModule />} />
//               {/* <Route path="leadgen/*" element={<LeadGenModule />} /> */}
//             </Routes>
//                     </section>
//             </div>
//           </div>
//         </div>
//     </div>
//     </SidebarProvider>
//   )
// }

// export default portal

import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import TopBar from './topbar/TopBar';
import './portal.css';
import SideBar from './Sidebar/SideBar';
import UserManagmntModule from './usersMangmnt/UserManagmntModule';
import { SidebarContext, SidebarProvider } from './Sidebar/SidebarContext';
import React, { useContext, useState } from 'react';
import LeadsModule from './leads/LeadsModule';
import PostsModule from './posts/PostsModule';
import ProposalModule from './Proposals/ProposalModule';
import BookedModule from './Booking/BookedModule';
import ContentCompaniesModule from './posts/contentCompanies/ContentCompaniesModule';
import PostManagementModule from './PostManagement/PostManagementModule';
import PatientsModule from './patients/patientsModule';
import SectorsModule from './Sectors/SectorsModule';
import VendorMudule from './vendors/VendorMudule';
import EnquiriesModule from './Enquiries/EnquiriesModule';
import SeoSettingsModule from './SeoSettings/SeoSettingsModule';

function Portal() {
  const { isSidebarCollapsed, toggleSidebar } = useContext(SidebarContext);
  return (
    // <SidebarProvider>
    <div>
      <div className='bg-color h-screen overflow-x-scroll sm:overflow-x-auto'>
        <div className='flex overflow-x-scroll'>
          <div
            className={`${
              isSidebarCollapsed ? 'md:w-[7%]' : 'md:w-[17%]'
            } h-screen sm:w-0`}
          >
            <SideBar />
          </div>

          <div
            className={`${
              !isSidebarCollapsed ? 'md:w-[83%]' : 'md:w-[93%]'
            } sm:w-[100%] w-full bg-[#F6F6F6]`}
          >
            {/* <div className="md:w-[85%] sm:w-[100%] w-full bg-[#F6F6F6]"> */}
            <div
              className={` ${
                !isSidebarCollapsed ? 'md:w-[84.2%] ' : 'md:w-[92.2%] '
              } sm:w-[100%] w-full`}
            >
              <TopBar />
            </div>
            <section className='sm:content pb-3.5 w-full pt-[85px] mx-auto px-8'>
              <Routes>
                <Route path='userManagmnt/*' element={<UserManagmntModule />} />
                <Route path='posts/*' element={<PostsModule />} />
                <Route path='leads/*' element={<LeadsModule />} />
                <Route path='patients/*' element={<PatientsModule />} />
                <Route path='proposals/*' element={<ProposalModule />} />
                <Route path='bookings/*' element={<BookedModule />} />
                <Route
                  path='contentCompanies/*'
                  element={<ContentCompaniesModule />}
                />
                <Route
                  path='postManagement/*'
                  element={<PostManagementModule />}
                />
                <Route path='seoSettings/*' element={<SeoSettingsModule />} />
                <Route path='sectors/*' element={<SectorsModule />} />
                <Route path='vendors/*' element={<VendorMudule />} />
                <Route path='enquiries/*' element={<EnquiriesModule />} />
                {/* Add other routes here */}
              </Routes>
            </section>
          </div>
        </div>
      </div>
    </div>
    // </SidebarProvider>
  );
}

export default Portal;
